import { Component, OnInit } from '@angular/core';
import { EventEmitterService } from 'services/event-emitter.service';
import { ProspectService } from 'services/prospect.service';
import { Router } from '@angular/router';
import { ProspectTourScheduleSelftour } from 'app/models/prospect-tour-schedule-selftour';
import { ProspectTourScheduleResult } from 'app/models/prospect-tour-schedule-result';
import { ErrorService } from 'services/error.service';
import { SplashService } from 'services/splash.service';
import { LabelValue } from 'app/models/labelvalue';
import { zoneTourStartTimes } from 'app/interface/zoneTourStartTimes';
import { ProspectProfileInfo } from 'app/models/prospect-profile-info';
import { IncomePeriod } from 'enumerations/income-period';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { IncomeRequirementsComponent } from './income-requirements/income-requirements.component';
import { ApplicationDataService } from 'services/application.service';
import { buildSelfTourTimes } from './self-tour-times';

@Component({
  selector: 'app-schedule-selftour',
  templateUrl: './schedule-selftour.component.html',
  styleUrls: ['./schedule-selftour.component.css']
})
export class ScheduleSelftourComponent implements OnInit {

  times: LabelValue [];
  model: ProspectTourScheduleSelftour = new ProspectTourScheduleSelftour();
  prospectInfo :ProspectProfileInfo=new ProspectProfileInfo();
  errorMessage: String = null;
  isProcessing: boolean = false;
  minDateValue: Date;
  maxDateValue: Date;
  maxMoveInDateValue:Date;
  confirmInfoLink: boolean = false;
  summaryRedirect: boolean = false;
  tourStartTimes: zoneTourStartTimes;

  incomePeriods: LabelValue[] = [
    { label:'Per Month', value: IncomePeriod.PerMonth},
    { label:'Per Year', value: IncomePeriod.PerYear}
  ];

  incomeAmount: number;
  currentRentAmount: number

  constructor(
    private eventEmitterService: EventEmitterService,
    private prospectService:
    ProspectService,
    public router: Router,
    private errorService: ErrorService,
    private splashService: SplashService,
    public incomeRequirementsDialog: MatDialog,
    private applicationService: ApplicationDataService) {

    this.eventEmitterService.selfTourStepChange(4);

    this.minDateValue = new Date();
    this.maxDateValue = new Date();
    this.maxMoveInDateValue = new Date();
    this.maxDateValue.setDate(this.minDateValue.getDate() + 13);

    this.model.LoadFromLocalTourQueryParams();

    let yardiKey = localStorage.getItem('YardiID');

    if (yardiKey !== null && yardiKey !== undefined)
    {
      this.model.YardiKey = yardiKey;
    }

    this.getDefaultDateandTime();

    let summaryError = localStorage.getItem('SummaryError');

    if (summaryError !== null && summaryError !== undefined)
    {
      this.summaryRedirect = true;
    }
    else{
      this.prospectService.CheckForValidPayment().subscribe(res => this.onCheckForValidPayment(res), res => this.errorService.showError(res));
    }
    this.prospectService.getProspectProfileInfo().subscribe(res => this.onGetProspectProfileInfo(res), res => this.errorService.showError("Error getting user information."));

  }

  ngOnInit() {
    this.splashService.updateSplash("selftour");
    this.applicationService.getPropertyForShowing(this.model.YardiKey).subscribe(res => this.setRentAmount(res));
  }

  setRentAmount(res) {
    if (res !== null && res.results !== null && res.results[0] !== null && /^[0-9]+$/.test(res.results[0].rent)) {
      this.currentRentAmount = Number(res.results[0].rent);
    }
  }

  onGetProspectProfileInfo(info: ProspectProfileInfo)
  {
    if(!this.isDateInPast(info.PreferredMoveIn)){
      this.prospectInfo.PreferredMoveIn=info.PreferredMoveIn;
    }
    this.incomeAmount=info.IncomeAmount;
    this.prospectInfo.IncomePeriod = IncomePeriod.PerMonth
    this.prospectService.getPropertyZone(this.model.YardiKey).subscribe(res => this.onGetPropertyZone(res), res => this.errorService.showError(res));

  }
  isDateInPast(chosenDate:Date): boolean{
    if(chosenDate===null) return false;
    let currentDate=new Date();
    let compareDate=new Date(chosenDate);
    currentDate.setHours(0,0,0);
    compareDate.setHours(0,0,0);
    return currentDate>compareDate;

  }
  onGetPropertyZone(res: zoneTourStartTimes) {
    this.tourStartTimes = res;
    this.times = this.getTimes();
    
    const isCurrentTimeValid = this.times.some(t => t.value === this.model.TourTime);
    if (!isCurrentTimeValid && this.times.length > 0) {
      let selectedTime = this.times[0].value;

      const today = new Date();
      const tourDate = this.model.TourDate ? new Date(this.model.TourDate) : null;

      if (tourDate && tourDate.toDateString() === today.toDateString()) {
        const currentHours = today.getHours().toString().padStart(2, '0');
        const currentMinutes = today.getMinutes().toString().padStart(2, '0');
        const currentTime = `${currentHours}:${currentMinutes}`;

        const futureSlot = this.times.find(t => t.value >= currentTime);

        if (futureSlot) {
          selectedTime = futureSlot.value;
        } else {
          const nextDay = new Date(today);
          nextDay.setHours(0, 0, 0, 0);
          nextDay.setDate(today.getDate() + 1);
          this.model.TourDate = nextDay;
          selectedTime = this.times[0].value;
        }
      }

      this.model.TourTime = selectedTime;
    }
  }

  getDefaultDateandTime()
  {
    this.model.TourDate = new Date();
    let tempDefaultTime = new Date();

    let ms = 1800000; // 30 minutes in ms
    let roundedDate = new Date(Math.ceil(tempDefaultTime.getTime() / ms) * ms);

    const hours = roundedDate.getHours().toString().padStart(2, '0');
    const minutes = roundedDate.getMinutes().toString().padStart(2, '0');
    this.model.TourTime = `${hours}:${minutes}`;
  }

  onCheckForValidPayment(valid: boolean)
  {
    if (!valid)
    {
      this.router.navigate(['/tour/selftour/submit-payment']);
    }
  }

  getTimes() {
    return buildSelfTourTimes(
      this.tourStartTimes.SelfTourStartHour,
      this.tourStartTimes.SelfTourStartMinute,
      this.tourStartTimes.SelfTourEndHour,
      this.tourStartTimes.SelfTourEndMinute);
  }

  showIncomeRequirementsDialog() {

    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = "300px";

    let dialogRef = this.incomeRequirementsDialog.open(IncomeRequirementsComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
        if (result === "scheduletour") {
          this.continueSubmit()
        }
    });
  }

  submit()
  {
    if (this.summaryRedirect) {
      this.router.navigate(['/tour/selftour/summary-selftour']);
    } else {

      if (this.prospectInfo.IncomePeriod === IncomePeriod.PerYear) {
        this.prospectInfo.IncomeAmount = Math.round(this.incomeAmount / 12);
      } else {
        this.prospectInfo.IncomeAmount = this.incomeAmount
      }

      if (this.currentRentAmount !== null && this.currentRentAmount * 3 > this.prospectInfo.IncomeAmount) {
        this.showIncomeRequirementsDialog()
      } else {
        this.continueSubmit();
      }
    }
  }

  continueSubmit() {
    this.errorMessage = null;
    this.isProcessing = true;
    this.confirmInfoLink = false;
    this.model.TourDateString = new Date(this.model.TourDate).toDateString();

    let source = localStorage.getItem('Source');

    if (source !== null && source !== undefined)
    {
      this.model.ProspectSource = source;
    }

    this.prospectService.updateProspectProfileInfo(this.prospectInfo).subscribe(res => this.updateSuccess(res), res => this.errorService.showError("Error updating user info."));
  }

  updateSuccess(res: boolean){
      this.prospectService.ScheduleSelfTour(this.model).subscribe(res => this.onSubmit(res), res => this.submitError(res));
  }

  onSubmit(res: ProspectTourScheduleResult)
  {
    if (res.Error !== null)
    {
      this.isProcessing = false;
      this.errorMessage = res.Error;
    }
    else if (res.ProspectSelfTourKey !== null)
    {
      localStorage.setItem('SelfTourKey', res.ProspectSelfTourKey);
      this.router.navigate(['/tour/selftour/summary-selftour']);
    }
    else {
      this.isProcessing = false;
      this.errorMessage = "Error scheduleing self tour.";
    }

  }

  submitError(err: any)
  {
    this.isProcessing = false;
    this.errorService.showError(err);
  }

  back()
  {
    this.router.navigate(['/tour/selftour/confirm-info']);
  }

}
